import * as React from 'react';
import { useMemo } from 'react';

import type { Domain_Subdomain } from '__generated__/graphql-types';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/consumer-home';

type Props = {
  subdomains?: Array<Pick<Domain_Subdomain, 'id' | 'name'>>;
};
const MAX_SUBDOMAINS_TO_SHOW = 3;

const getSubdomainText = (subdomains?: Array<Pick<Domain_Subdomain, 'id' | 'name'>>) => {
  if (!subdomains) {
    return '';
  }
  const subdomainList = subdomains
    .slice(0, MAX_SUBDOMAINS_TO_SHOW)
    .map((subdomain) => subdomain?.name)
    .join(', ');
  const subdomainsLength = subdomains.length;

  return subdomainsLength <= MAX_SUBDOMAINS_TO_SHOW
    ? subdomainList
    : _t('#{subdomainList}, + #{remainSubdomains} more', {
        subdomainList,
        remainSubdomains: subdomainsLength - MAX_SUBDOMAINS_TO_SHOW,
      });
};

const SubdomainText = ({ subdomains }: Props) => {
  const subdomainText = useMemo(() => getSubdomainText(subdomains), [subdomains]);

  if (!subdomainText) {
    return null;
  }

  return (
    <Typography2 component="p" variant="bodySecondary" color="invertBody">
      {subdomainText}
    </Typography2>
  );
};

export default SubdomainText;
